@if (images().length > 0) {
  <div class="relative overflow-hidden rounded-(--carousel-border-radius)">
    <p-carousel
      [value]="images()"
      [numVisible]="1"
      [numScroll]="1"
      [circular]="circular()"
      [showIndicators]="showIndicators()"
      [showNavigators]="showNavigators()"
      class="carousel"
    >
      <ng-template
        #item
        let-image
      >
        <img
          [src]="image"
          alt="Carousel image"
          class="w-full object-cover rounded-(--carousel-border-radius)"
          [style]="imageStyle()"
        />
      </ng-template>
      <ng-template #previousicon>
        <app-dynamic
          componentName="SvgIcon"
          [props]="{ name: 'chevron-left', size: '16' }"
        />
      </ng-template>
      <ng-template #nexticon>
        <app-dynamic
          componentName="SvgIcon"
          [props]="{ name: 'chevron-right', size: '16' }"
        />
      </ng-template>
    </p-carousel>
  </div>
}
